import ExhibitorEditText from './ExhibitorEditText';

const ExhibitorEditAbout = () => {
    return (
        <ExhibitorEditText fname='about' subtitle='exhibitoredit.about_hint' limit={600} />
	);
};

export default ExhibitorEditAbout;
